import { PostContent } from '@3m5/sm_publish-frontend-api'

export enum Customer {
  default = 'default',
  ergo = 'ergo',
  huk = 'huk',
  dvag = 'dvag',
  allianz = 'allianz',
  barmenia = 'barmenia',
  concordia = 'concordia',
  generali = 'generali',
  localyzer = 'localyzer',
  marcapo = 'marcapo',
  nuernberger = 'nuernberger',
  ovb = 'ovb',
  provinzial = 'provinzial',
  vkb = 'vkb',
  vrk = 'vrk',
  wuestenrotAT = 'wuestenrotAT',
  wuw = 'wuw',
  emasters = 'emasters',
  sanacorp = 'sanacorp',
  sympany = 'sympany',
}

export interface IIconProps {
  width?: string
  color?: string
  className?: string
}

export enum PostingType {
  photo='PHOTO',
  link='LINK',
  video='VIDEO',
  message='MESSAGE',
}

export interface Topic {
  id: string // UUID
  name: string
  description: string
  picture: string
}

export interface Tag {
  id: string // UUID
  label: string
}

export interface PostTemplate{
  id: string // ist eine UUID
  postContent: PostContent
  postMetadata?: {
    headline: string
    text: string
    imageUrl?: string // wird beim editieren in separatem request gespeichert (entweder mediaId oder externe url)
  }
  createdAt: number
  updatedAt?: number
  postStart: number
  postEnd?: number
  linkIndividualizationAllowed: boolean
  hashtagIndividualizationAllowed: boolean
  topic?: Topic
  tags: Tag[]
  allowedNetworks: {
    [key: string]: boolean
    facebook: boolean
    instagram: boolean
    googleMyBusiness: boolean
  }
}

export interface Network {
  status: DeferredPostStatus
  plannedPostingTime: number
  aboStatus: AboStatus
  statusChangedAt: number
  networkPageId: string
  networkPostId?: string
  networkPageName: string
  networkType: NetworkType
}

export interface PostTemplateListUser {
  postTemplate: PostTemplate
  networks: Network[]
  postType?: string
}

// export enum FacebookPostStatistic {
//   comment = 'comment',
//   like = 'like',
//   reaction_angry = 'reaction_angry',
//   reaction_care = 'reaction_care',
//   reaction_haha = 'reaction_haha',
//   reaction_like = 'reaction_like',
//   reaction_love = 'reaction_love',
//   reaction_none = 'reaction_none',
//   reaction_sad = 'reaction_sad',
//   reaction_thankful = 'reaction_thankful',
//   reaction_wow = 'reaction_wow',
//   reaction_pride = 'reaction_pride',
//   reaction_fire = 'reaction_fire',
//   reaction_hundred = 'reaction_hundred',
//   share = 'share',
//   view = 'view',
//   uniqueView = 'uniqueView',
//   engagementRate = 'engagementRate',
//   reachedFansPercent = 'reachedFansPercent',
//   impressionsOrganic = 'impressionsOrganic',
//   impressionsPaid = 'impressionsPaid',
// }

export enum NetworkType {
  Instagram='Instagram',
  Facebook='Facebook',
  GoogleMyBusiness='GoogleMyBusiness',
}

export enum DeferredPostStatus {
  NotYetAvailable = 'NotYetAvailable', // bereits für Zukunft redaktionell in bestimmter Topic geplant
  Available = 'Available', // Vorlage zum Posten bereit
  Planned = 'Planned', // vom user für bestimmten Zeitpunkt geplant
  Posting = 'Posting', // Posten läuft gerade
  PostedSuccessfully = 'PostedSuccessfully', // erfolgreich gepostet
  ErrorWhilePosting = 'ErrorWhilePosting', // Posting fehlgeschlagen
  WaitingForConfirmation = 'WaitingForConfirmation' // Topic manuell
}

export enum AboStatus {
  Individual = 'Individual',
  Automatic = 'Automatic',
  Off = 'Off',
}

export interface SocialMediaNetwork {
  [key: string]: boolean
}

export interface MetaData {
  imageDataBase64?: string
  picture?: string
  text?: string
}
